"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqName = exports.NamePrefix = exports.getNewIds = exports.getNewId = exports.IDPrefix = void 0;
const i18n_1 = require("../exports/i18n");
const string_1 = require("./string");
const EFFECTIVE_ID_LENGTH = 10;
var IDPrefix;
(function (IDPrefix) {
    IDPrefix["Table"] = "dst";
    IDPrefix["View"] = "viw";
    IDPrefix["Record"] = "rec";
    IDPrefix["Field"] = "fld";
    IDPrefix["Option"] = "opt";
    IDPrefix["Condition"] = "cdt";
    IDPrefix["File"] = "atc";
    IDPrefix["Comment"] = "cmt";
    IDPrefix["WidgetPanel"] = "wpl";
    IDPrefix["Editor"] = "edt";
    IDPrefix["SPACE"] = "spc";
    IDPrefix["DateTimeAlarm"] = "dta";
    IDPrefix["EmbedLink"] = "emb";
    IDPrefix["Form"] = "fom";
    IDPrefix["Dashboard"] = "dsb";
})(IDPrefix = exports.IDPrefix || (exports.IDPrefix = {}));
/**
 * Generate unique new id
 * @param {IDPrefix} prefix new id prefix
 * @param {string[]} [ids=[]] Existing ids, will not be repeated with this group
 * @returns {string}
 */
function getNewId(prefix, ids = []) {
    return getNewIds(prefix, 1, ids)[0];
}
exports.getNewId = getNewId;
/**
 * Generate a new set of unique ids
 * @param {IDPrefix} prefix new id prefix
 * @param {number} num the expected number
 * @param {string[]} [ids=[]] Existing ids, will not be repeated with this group
 * @returns {string[]}
 */
function getNewIds(prefix, num, ids = []) {
    if (num <= 0)
        return [];
    const newIds = [];
    const idMap = ids.reduce((prev, id) => {
        prev[id] = true;
        return prev;
    }, {});
    for (let i = 0; i < num; i++) {
        let newId;
        do {
            newId = `${prefix}${(0, string_1.generateRandomString)(EFFECTIVE_ID_LENGTH)}`;
        } while (idMap[newId]);
        newIds.push(newId);
        idMap[newId] = true;
    }
    return newIds;
}
exports.getNewIds = getNewIds;
exports.NamePrefix = {
    Field: (0, i18n_1.t)(i18n_1.Strings.field),
    GridView: (0, i18n_1.t)(i18n_1.Strings.grid_view),
    KanbanView: (0, i18n_1.t)(i18n_1.Strings.kanban_view),
    GalleryView: (0, i18n_1.t)(i18n_1.Strings.gallery_view),
    FormView: (0, i18n_1.t)(i18n_1.Strings.form_view),
    CalendarView: (0, i18n_1.t)(i18n_1.Strings.calendar_view),
    GanttView: (0, i18n_1.t)(i18n_1.Strings.gantt_view),
    OrgChartView: (0, i18n_1.t)(i18n_1.Strings.org_chart_view),
    View: (0, i18n_1.t)(i18n_1.Strings.view), // 'View',
};
/**
 * Get safe and unique names
 * @param newName the name you want to take
 * @param names An array of existing names, if there are duplicates, suffixes will be added automatically
 */
function getUniqName(newName, names) {
    let index = 1;
    const nameMap = names.reduce((prev, name) => {
        prev[name] = true;
        return prev;
    }, {});
    let uniqName = newName;
    while (nameMap[uniqName]) {
        uniqName = `${newName} ${++index}`;
    }
    return uniqName;
}
exports.getUniqName = getUniqName;
//# sourceMappingURL=uuid.js.map